module.exports = __webpack_public_path__ + "static/media/thumb.5cb690b1.svg";